import React, { useEffect } from 'react';
import { AppProps } from 'next/app';
import { initializeRio } from '@src/lib/rio';
import { initClient } from '@chegg/rio2-web-client';

initializeRio();

const App: React.FC<AppProps> = (props) => {
  const { pageProps, Component } = props;

  useEffect(() => {
    initClient();
  }, []);

  return <Component {...pageProps} />;
};

export default App;
